import { normalizeTel } from '@amo/core/utils/normalize.js';
import _ from 'lodash';
import moment from 'moment';
import {
    getAdresse1SouscripteurDemandeTarifInit,
    getAdresse2SouscripteurDemandeTarifInit,
    getAdresse3SouscripteurDemandeTarifInit,
    getAnnulationPermisAntecedentsDemandeTarifInit,
    getAntecedentsDemandeTarifInit,
    getApporteur1Init,
    getApporteur2Init,
    getAssure3DerniersMoisVehiculeDemandeTarifInit,
    getBirthCityPersonnePrincipaleDemandeTarifInit,
    getBirthDepartmentPersonnePrincipaleDemandeTarifInit,
    getBirthCityTuteurDemandeTarifInit,
    getBirthCountryPersonnePrincipaleDemandeTarifInit,
    getBirthCountryTuteurDemandeTarifInit,
    getBirthNamePersonnePrincipaleDemandeTarifInit,
    getBirthNameTuteurDemandeTarifInit,
    getCPSouscripteurDemandeTarifInit,
    getCanalDemandeTarifInit,
    getCarteGriseFrancaiseVehiculeDemandeTarifInit,
    getCivilitePersonneMoraleTarif,
    getCivilitePersonnePrincipaleDemandeTarifInit,
    getCiviliteTuteurDemandeTarifInit,
    getCodePostalGarageVehiculeDemandeTarifInit,
    getCodePromoDemandeTarifInit,
    getCondamnationAlcoolemieAntecedentsDemandeTarifInit,
    getCondamnationConduiteSansAssuranceAntecedentsDemandeTarifInit,
    getCondamnationDelitFuiteAntecedentsDemandeTarifInit,
    getCondamnationStupefiantsAntecedentsDemandeTarifInit,
    getConducteurMineurPersonnePrincipaleDemandeTarifInit,
    getConnuCommentInit,
    getCrmAuto50Plus3AnsPersonnePrincipaleDemandeTarifInit,
    getCrmMoto50Plus3AnsPersonnePrincipaleDemandeTarifInit,
    getDateMECVehiculeDemandeTarif,
    getDateNaissancePersonnePrincipaleDemandeTarifInit,
    getDateNaissanceTuteurDemandeTarifInit,
    getDevisHamonAssureurActuelIdDemandeContratInit,
    getDevisHamonAssureurActuelIdDemandeTarifInit,
    getDevisHamonAssureurActuelNameDemandeContratInit,
    getDevisHamonAssureurActuelNameDemandeTarifInit,
    getDevisHamonContratActuelDemandeContratInit,
    getDevisHamonContratActuelDemandeTarifInit,
    getDevisHamonDemandeContratInit,
    getDevisHamonDemandeTarifInit,
    getDevoirASS2DevoirConseilDemandeTarifInit,
    getDevoirASS3DevoirConseilDemandeTarifInit,
    getDevoirAccEqpDevoirConseilDemandeTarifInit,
    getDevoirDommageDevoirConseilDemandeTarifInit,
    getDevoirICDevoirConseilDemandeTarifInit,
    getDevoirMontantAccEqpDevoirConseilDemandeTarifInit,
    getDevoirRachatDevoirConseilDemandeTarifInit,
    getDevoirVolDevoirConseilDemandeTarifInit,
    getEmailSouscripteurTarif,
    getFormuleChoisiePoliceDemandeTarifInit,
    getFractionnementPoliceDemandeTarifInit,
    getGPDemandeTarifInit,
    getIdSocietyPersonneMoraleTarif,
    getIdentifiantSRAVehiculeDemandeTarifInit,
    getImmatriculationVehiculeDemandeTarifInit,
    getLegalStatusPersonneMoraleTarif,
    getListePermisPersonnePrincipaleDemandeTarifInit,
    getListeSinistresAntecedentsDemandeTarifInit,
    getNbMoisAssuranceAutoPersonnePrincipaleDemandeTarifInit,
    getNbMoisAssuranceMotoPersonnePrincipaleDemandeTarifInit,
    getNomPersonneMoraleTarif,
    getNomPersonnePrincipaleDemandeTarifInit,
    getNomTitulaireDemandeContratInit,
    getNomTuteurDemandeTarifInit,
    getNumPermisSouscripteurTarif,
    getOptionsDemandeTarifInit,
    getOptionsFranchiseDemandeTarifInit,
    getOptionsListeDemandeTarifInit,
    getPermisA1PersonnePrincipaleDemandeTarifInit,
    getPermisA2PersonnePrincipaleDemandeTarifInit,
    getPermisAMPersonnePrincipaleDemandeTarifInit,
    getPermisAPersonnePrincipaleDemandeTarifInit,
    getPermisBPersonnePrincipaleDemandeTarifInit,
    getPersonneMoraleDemandeTarifInit,
    getPersonnePrincipaleIsSouscripteurDemandeTarifInit,
    getPrenomPersonnePrincipaleDemandeTarifInit,
    getPrenomTuteurDemandeTarifInit,
    getSignatureEmailDemandeContratInit,
    getSignaturePhoneDemandeContratInit,
    getState,
    getSuspensionPermisAntecedentsDemandeTarifInit,
    getTelPortableSouscripteurTarif,
    getTiersPayeurBirthCityDemandeContratInit,
    getTiersPayeurBirthCountryDemandeContratInit,
    getTiersPayeurBirthDateDemandeContratInit,
    getTiersPayeurBirthNameDemandeContratInit,
    getTiersPayeurDemandeContratInit,
    getTiersPayeurFirstNameDemandeContratInit,
    getTiersPayeurLastNameDemandeContratInit,
    getTiersPayeurRelationshipDemandeContratInit,
    getTiersPayeurThirdPayerReasonDemandeContratInit,
    getTiersPayeurTypeDemandeContratInit,
    getTuteurDemandeTarifInit,
    getUsageNonLivraisonVehiculeDemandeTarifInit,
    getUsageVehiculeDemandeTarif,
    getValeurCrmAutoPersonnePrincipaleDemandeTarifInit,
    getValeurCrmMotoPersonnePrincipaleDemandeTarifInit,
    getValeurVehiculeVehiculeDemandeTarifInit,
    getVehiculeImmatriculeVehiculeDemandeTarifInit,
    getVilleGarageVehiculeDemandeTarifInit,
    getVilleSouscripteurDemandeTarifInit,
    getPossessionPlusDe3MoisVehiculeDemandeTarifInit,
    getDateHeureEffetDemandeContratInit,
    getDateAchatVehiculeDemandeTarif,
    getParrainageDemandeTarifInit,
    getNumeroClientSouscripteurDemandeTarif,
    getDejaClientSouscripteurDemandeTarif,
    getNumeroClientPersonnePrincipaleDemandeTarif,
    getDejaClientPersonnePrincipaleDemandeTarif,
    getIBANDemandeContratInit,
    getBICDemandeContratInit,
    getFormationPersonnePrincipaleDemandeTarifInit,
    getDeclarationAssurancePersonnePrincipaleDemandeTarifInit,
    getEligibleMultidetentionVehiculeDemandeTarifInit,
    getContratEligibleDemandeTarifInit,
    getVINVehiculeDemandeTarifInit, getPhoneContactConsentInit, getEmailContactConsentInit
} from '../../../redux/selectors/init/init.selectors';
import {
    getCodeCategorieVehicule,
    getCylindreeVehicule,
    getMarqueVehicule,
    getSraVehicule,
    getTypeVehicule,
} from '../../../redux/selectors/vehicule/vehicule.selectors';
import {
    getListePersonnes0Adresse1DejaClient,
    getListePersonnes0Adresse2DejaClient,
    getListePersonnes0Adresse3DejaClient,
    getListePersonnes0CPDejaClient,
    getListePersonnes0VilleDejaClient
} from "../../../redux/selectors/dejaClient/dejaClient.selectors.js";

export const InitialValues = (state) => {
    const isDevisOrDevisOrange = getState(state) === 'devis' || getState(state) === 'devis_orange';
    //On a besoin du rechargement des données dès le tarif pour certains champs
    const notNew = getState(state) !== 'new';

    /* Un DemandeDevis dont aucun champ n'est renseigné se sérialise en `{}`, que devis-ws
       décode en tableau vide. Or un tableau vide écrase le bloc stocké au lieu de le compléter
       (isAssoc([]) === false dans array_merge_recursive_distinct_custom) : le premier fill
       effacerait le TypeMER et l'IdConversation posés à la création de la session. On ne
       transmet donc le bloc que s'il porte au moins une valeur. */
    const demandeDevis = _.omitBy(
        {
            ConnuComment: getConnuCommentInit(state),
            PhoneContactConsent: _.includes(['true', '1', true], getPhoneContactConsentInit(state))
                ? 'true'
                : _.includes(['false', '0', false], getPhoneContactConsentInit(state))
                    ? 'false'
                    : undefined,
            EmailContactConsent: _.includes(['true', '1', true], getEmailContactConsentInit(state))
                ? 'true'
                : _.includes(['false', '0', false], getEmailContactConsentInit(state))
                    ? 'false'
                    : undefined,
        },
        _.isUndefined,
    );

    return {
        redirection: false,
        searchBy: 'immatriculation',
        typeVehicule: getTypeVehicule(state),
        codeCategorie: getCodeCategorieVehicule(state),
        marqueVehicule: getMarqueVehicule(state),
        modeleVehicule: getSraVehicule(state),
        cylindreeVehicule: getCylindreeVehicule(state) && String(getCylindreeVehicule(state)),
        options: getOptionsDemandeTarifInit(state),
        optionsFranchise: getOptionsFranchiseDemandeTarifInit(state),
        optionsListe: getOptionsListeDemandeTarifInit(state),
        /* Vérifier avec les selectors getAssureMotoInit ? */
        assure_moto: isDevisOrDevisOrange
            ? getNbMoisAssuranceMotoPersonnePrincipaleDemandeTarifInit(state)
                ? '1'
                : '0'
            : undefined,
        assure_auto: isDevisOrDevisOrange
            ? getNbMoisAssuranceAutoPersonnePrincipaleDemandeTarifInit(state)
                ? '1'
                : '0'
            : undefined,
        /* Déduction de la valeur entre societe ou a son nom, impossible entre nom de l'enfant ou a votre nom */
        titulaireCarteGrise:
            getPersonneMoraleDemandeTarifInit(state) && getCivilitePersonneMoraleTarif(state)
                ? '2'
                : getNomPersonnePrincipaleDemandeTarifInit(state) || getPrenomPersonnePrincipaleDemandeTarifInit(state)
                ? '1'
                : undefined,
        sinistre_auto: isDevisOrDevisOrange
            ? getListeSinistresAntecedentsDemandeTarifInit(state) &&
              getListeSinistresAntecedentsDemandeTarifInit(state).length > 0
                ? '1'
                : '0'
            : undefined,
        ...(_.isEmpty(demandeDevis) ? {} : { DemandeDevis: demandeDevis }),
        // DejaClient: {
        //     Adresse1: getListePersonnes0Adresse1DejaClient(state),
        //     Adresse2: getListePersonnes0Adresse2DejaClient(state),
        //     Adresse3: getListePersonnes0Adresse3DejaClient(state),
        //     CP: getListePersonnes0CPDejaClient(state),
        //     Ville: getListePersonnes0VilleDejaClient(state),
        // },
        DemandeTarif: {
            Parrainage: getParrainageDemandeTarifInit(state),
            GoodbyePack: getGPDemandeTarifInit(state),
            DevisHamon: getDevisHamonDemandeTarifInit(state),
            DevisHamonAssureurActuelName: getDevisHamonAssureurActuelNameDemandeTarifInit(state),
            DevisHamonAssureurActuelId: getDevisHamonAssureurActuelIdDemandeTarifInit(state),
            DevisHamonContratActuel: getDevisHamonContratActuelDemandeTarifInit(state),
            CodePromo: {
                CodePromo: getCodePromoDemandeTarifInit(state),
            },
            Police: {
                Canal: getCanalDemandeTarifInit(state),
                FractionnementChoisi: getFractionnementPoliceDemandeTarifInit(state) || 'M',
                FormuleChoisie: getFormuleChoisiePoliceDemandeTarifInit(state),
                IdApporteur1: getApporteur1Init(state)?.codeBelair,
                IdApporteur2: getApporteur2Init(state)?.codeBelair,
            },
            ListePersonnes: [
                {
                    TypePersonne: 'P',
                    RoleConducteur: 'P',
                    Souscripteur:
                        getDateNaissancePersonnePrincipaleDemandeTarifInit(state) &&
                        moment(getDateNaissancePersonnePrincipaleDemandeTarifInit(state), 'DD/MM/YYYY').add(
                            18,
                            'years',
                        ) > moment()
                            ? false
                            : getPersonnePrincipaleIsSouscripteurDemandeTarifInit(state) !== 'false',
                    DateNaissance:
                        getDateNaissancePersonnePrincipaleDemandeTarifInit(state) &&
                        moment(getDateNaissancePersonnePrincipaleDemandeTarifInit(state), 'DD/MM/YYYY'),
                    ListePermis:
                        getListePermisPersonnePrincipaleDemandeTarifInit(state).length > 0
                            ? [
                                  {
                                      TypePermis: getPermisAMPersonnePrincipaleDemandeTarifInit(state).TypePermis,
                                      DatePermis:
                                          getPermisAMPersonnePrincipaleDemandeTarifInit(state).DatePermis &&
                                          moment(
                                              getPermisAMPersonnePrincipaleDemandeTarifInit(state).DatePermis,
                                              'DD/MM/YYYY',
                                          ),
                                  },
                                  {
                                      TypePermis: getPermisA1PersonnePrincipaleDemandeTarifInit(state).TypePermis,
                                      DatePermis:
                                          getPermisA1PersonnePrincipaleDemandeTarifInit(state).DatePermis &&
                                          moment(
                                              getPermisA1PersonnePrincipaleDemandeTarifInit(state).DatePermis,
                                              'DD/MM/YYYY',
                                          ),
                                  },
                                  {
                                      TypePermis: getPermisA2PersonnePrincipaleDemandeTarifInit(state).TypePermis,
                                      DatePermis:
                                          getPermisA2PersonnePrincipaleDemandeTarifInit(state).DatePermis &&
                                          moment(
                                              getPermisA2PersonnePrincipaleDemandeTarifInit(state).DatePermis,
                                              'DD/MM/YYYY',
                                          ),
                                  },
                                  {
                                      TypePermis: getPermisAPersonnePrincipaleDemandeTarifInit(state).TypePermis,
                                      DatePermis:
                                          getPermisAPersonnePrincipaleDemandeTarifInit(state).DatePermis &&
                                          moment(
                                              getPermisAPersonnePrincipaleDemandeTarifInit(state).DatePermis,
                                              'DD/MM/YYYY',
                                          ),
                                  },
                                  {
                                      TypePermis: getPermisBPersonnePrincipaleDemandeTarifInit(state).TypePermis,
                                      DatePermis:
                                          getPermisBPersonnePrincipaleDemandeTarifInit(state).DatePermis &&
                                          moment(
                                              getPermisBPersonnePrincipaleDemandeTarifInit(state).DatePermis,
                                              'DD/MM/YYYY',
                                          ),
                                  },
                              ]
                            : null,
                    Civilite: getCivilitePersonnePrincipaleDemandeTarifInit(state),
                    Nom: getNomPersonnePrincipaleDemandeTarifInit(state),
                    NumeroClient: getNumeroClientSouscripteurDemandeTarif(state) || getNumeroClientPersonnePrincipaleDemandeTarif(state),
                    DejaClient: _.includes(['true', '1', true], getDejaClientSouscripteurDemandeTarif(state)) ?'1' : (_.includes(['true', '1', true], getDejaClientPersonnePrincipaleDemandeTarif(state)) ?'1' : '0'),
                    Prenom: getPrenomPersonnePrincipaleDemandeTarifInit(state),
                    Adresse1: getAdresse1SouscripteurDemandeTarifInit(state),
                    Adresse2: getAdresse2SouscripteurDemandeTarifInit(state),
                    Adresse3: getAdresse3SouscripteurDemandeTarifInit(state),
                    Ville: getVilleSouscripteurDemandeTarifInit(state),
                    Formation: getFormationPersonnePrincipaleDemandeTarifInit(state),
                    DeclarationAssurance: getDeclarationAssurancePersonnePrincipaleDemandeTarifInit(state),
                    CP: getCPSouscripteurDemandeTarifInit(state),
                    TelPortable: normalizeTel(getTelPortableSouscripteurTarif(state)),
                    NumPermis: getNumPermisSouscripteurTarif(state),
                    Email: getEmailSouscripteurTarif(state),
                    ValeurCrmMoto: getValeurCrmMotoPersonnePrincipaleDemandeTarifInit(state)
                        ? String(Number(getValeurCrmMotoPersonnePrincipaleDemandeTarifInit(state))?.toFixed(2))
                        : null,
                    CrmMoto50Plus3Ans: getCrmMoto50Plus3AnsPersonnePrincipaleDemandeTarifInit(state),
                    ValeurCrmAuto: getValeurCrmAutoPersonnePrincipaleDemandeTarifInit(state)
                        ? String(Number(getValeurCrmAutoPersonnePrincipaleDemandeTarifInit(state))?.toFixed(2))
                        : null,
                    CrmAuto50Plus3Ans: getCrmAuto50Plus3AnsPersonnePrincipaleDemandeTarifInit(state),
                    NbMoisAssuranceMoto: getNbMoisAssuranceMotoPersonnePrincipaleDemandeTarifInit(state)
                        ? Number(getNbMoisAssuranceMotoPersonnePrincipaleDemandeTarifInit(state))?.toFixed(0)
                        : null,
                    NbMoisAssuranceAuto: getNbMoisAssuranceAutoPersonnePrincipaleDemandeTarifInit(state)
                        ? Number(getNbMoisAssuranceAutoPersonnePrincipaleDemandeTarifInit(state))?.toFixed(0)
                        : null,
                    BirthCountry: getBirthCountryPersonnePrincipaleDemandeTarifInit(state),
                    BirthCity: getBirthCityPersonnePrincipaleDemandeTarifInit(state),
                    BirthDepartment: getBirthDepartmentPersonnePrincipaleDemandeTarifInit(state),
                    BirthName: getBirthNamePersonnePrincipaleDemandeTarifInit(state),
                    ConducteurMineur: getConducteurMineurPersonnePrincipaleDemandeTarifInit(state) ?? false,
                    NbMoisReferenceMoto: '24',
                    NbMoisReferenceAuto: '24',
                },
                !_.isEmpty(getTuteurDemandeTarifInit(state))
                    ? {
                          Souscripteur: true,
                          TypePersonne: 'P',
                          RoleConducteur: 'N',
                          DateNaissance:
                              getDateNaissanceTuteurDemandeTarifInit(state) &&
                              moment(getDateNaissanceTuteurDemandeTarifInit(state), 'DD/MM/YYYY'),
                          Civilite: getCiviliteTuteurDemandeTarifInit(state),
                          Nom: getNomTuteurDemandeTarifInit(state),
                          Prenom: getPrenomTuteurDemandeTarifInit(state),
                          BirthCountry: getBirthCountryTuteurDemandeTarifInit(state),
                          BirthCity: getBirthCityTuteurDemandeTarifInit(state),
                          BirthName: getBirthNameTuteurDemandeTarifInit(state),
                      }
                    : !_.isEmpty(getPersonneMoraleDemandeTarifInit(state))
                    ? {
                          Souscripteur: true,
                          TypePersonne: 'M',
                          RoleConducteur: 'N',
                          Civilite: getCivilitePersonneMoraleTarif(state),
                          Nom: getNomPersonneMoraleTarif(state),
                          LegalStatus: getLegalStatusPersonneMoraleTarif(state),
                          IdSociety: getIdSocietyPersonneMoraleTarif(state),
                      }
                    : _.isEmpty(getTuteurDemandeTarifInit) &&
                      getDateNaissancePersonnePrincipaleDemandeTarifInit(state) &&
                      moment(getDateNaissancePersonnePrincipaleDemandeTarifInit(state), 'DD/MM/YYYY').add(18, 'years') >
                          moment()
                    ? {
                          Souscripteur: true,
                          TypePersonne: 'P',
                          RoleConducteur: 'N',
                          BirthCountry: getBirthCountryTuteurDemandeTarifInit(state),
                          BirthCity: getBirthCityTuteurDemandeTarifInit(state),
                          BirthName: getBirthNameTuteurDemandeTarifInit(state),
                      }
                    : undefined,
            ],
            Vehicule: {
                /* Force à non en cas de reprise pour poser la question (champs non retournés dans le devis-ws) */
                PossessionPlusDe3Mois: _.includes(['true', '1', true], getPossessionPlusDe3MoisVehiculeDemandeTarifInit(state)) ? '1' : undefined,
                VehiculeImmatricule: getImmatriculationVehiculeDemandeTarifInit(state)
                    ? '1'
                    : getVehiculeImmatriculeVehiculeDemandeTarifInit(state),
                SituationVehicule: '1',
                FamilleProduit: 'Moto',
                IdentifiantSRA: getIdentifiantSRAVehiculeDemandeTarifInit(state),
                DateAchatVehicule: getDateAchatVehiculeDemandeTarif(state) && moment(getDateAchatVehiculeDemandeTarif(state), 'DD/MM/YYYY'),
                DateMEC:
                    getDateMECVehiculeDemandeTarif(state) &&
                    moment(getDateMECVehiculeDemandeTarif(state), 'DD/MM/YYYY'),
                Assure3DerniersMois: _.includes(
                    ['true', '1', true],
                    getAssure3DerniersMoisVehiculeDemandeTarifInit(state),
                )
                    ? '1'
                    : _.includes(['false', '0', false], getAssure3DerniersMoisVehiculeDemandeTarifInit(state))
                    ? '0'
                    : undefined,
                UsageVehicule: getUsageVehiculeDemandeTarif(state),
                UsageNonLivraison: getUsageNonLivraisonVehiculeDemandeTarifInit(state),
                ValeurVehicule: getValeurVehiculeVehiculeDemandeTarifInit(state),
                CarteGriseFrancaise: getCarteGriseFrancaiseVehiculeDemandeTarifInit(state) && '1',
                VilleGarage: getVilleGarageVehiculeDemandeTarifInit(state),
                CodePostalGarage: getCodePostalGarageVehiculeDemandeTarifInit(state),
                Immatriculation: getImmatriculationVehiculeDemandeTarifInit(state),
                TitulaireCarteGrise: true,
                EligibleMultidetention: getEligibleMultidetentionVehiculeDemandeTarifInit(state),
                ContratEligible: getContratEligibleDemandeTarifInit(state),
                VIN: getVINVehiculeDemandeTarifInit(state)
            },
            Antecedents: {
                SuspensionPermis:
                    getSuspensionPermisAntecedentsDemandeTarifInit(state) === 'false' ||
                    getSuspensionPermisAntecedentsDemandeTarifInit(state) === '0'
                        ? '0'
                        : getSuspensionPermisAntecedentsDemandeTarifInit(state) === 'true' ||
                          getSuspensionPermisAntecedentsDemandeTarifInit(state) === '1'
                        ? '1'
                        : '',
                DateSuspensionPermis: getAntecedentsDemandeTarifInit(state).DateSuspensionPermis,
                NbMoisSuspensionPermis: getAntecedentsDemandeTarifInit(state).NbMoisSuspensionPermis,
                AnnulationPermis:
                    getAnnulationPermisAntecedentsDemandeTarifInit(state) === 'false' ||
                    getAnnulationPermisAntecedentsDemandeTarifInit(state) === '0'
                        ? '0'
                        : getAnnulationPermisAntecedentsDemandeTarifInit(state) === 'true' ||
                          getAnnulationPermisAntecedentsDemandeTarifInit(state) === '1'
                        ? '1'
                        : '',
                DateAnnulationPermis: getAntecedentsDemandeTarifInit(state).DateAnnulationPermis,
                CondamnationAlcoolemie: getCondamnationAlcoolemieAntecedentsDemandeTarifInit(state),
                TxAlcool: getAntecedentsDemandeTarifInit(state).TxAlcool,
                CondamnationStupefiants: getCondamnationStupefiantsAntecedentsDemandeTarifInit(state),
                CondamnationDelitFuite: getCondamnationDelitFuiteAntecedentsDemandeTarifInit(state),
                CondamnationConduiteSansAssurance:
                    getCondamnationConduiteSansAssuranceAntecedentsDemandeTarifInit(state),
                ResiliationAssureur: notNew
                    ? _.includes(['false', '0', false], getAntecedentsDemandeTarifInit(state).ResiliationAssureur)
                        ? '0'
                        : '1'
                    : false,
                MotifResiliationAssureur: getAntecedentsDemandeTarifInit(state).MotifResiliationAssureur,
                DateResiliationAssureur: getAntecedentsDemandeTarifInit(state).DateResiliationAssureur,
                ListeSinistres: getListeSinistresAntecedentsDemandeTarifInit(state),
            },
            DevoirConseil: {
                DevoirVol:
                    getDevoirVolDevoirConseilDemandeTarifInit(state) === 'false' ||
                    getDevoirVolDevoirConseilDemandeTarifInit(state) === '0'
                        ? '0'
                        : getDevoirVolDevoirConseilDemandeTarifInit(state) === 'true' ||
                          getDevoirVolDevoirConseilDemandeTarifInit(state) === '1'
                        ? '1'
                        : '',
                DevoirDommage:
                    getDevoirDommageDevoirConseilDemandeTarifInit(state) === 'false' ||
                    getDevoirDommageDevoirConseilDemandeTarifInit(state) === '0'
                        ? '0'
                        : getDevoirDommageDevoirConseilDemandeTarifInit(state) === 'true' ||
                          getDevoirDommageDevoirConseilDemandeTarifInit(state) === '1'
                        ? '1'
                        : '',
                DevoirASS2:
                    getDevoirASS2DevoirConseilDemandeTarifInit(state) === 'false' ||
                    getDevoirASS2DevoirConseilDemandeTarifInit(state) === '0'
                        ? '0'
                        : getDevoirASS2DevoirConseilDemandeTarifInit(state) === 'true' ||
                          getDevoirASS2DevoirConseilDemandeTarifInit(state) === '1'
                        ? '1'
                        : '',
                DevoirASS3: getDevoirASS3DevoirConseilDemandeTarifInit(state),
                DevoirIC: getDevoirICDevoirConseilDemandeTarifInit(state),
                DevoirACCESSEQP: getDevoirAccEqpDevoirConseilDemandeTarifInit(state),
                DevoirMontantACCESSEQP: getDevoirMontantAccEqpDevoirConseilDemandeTarifInit(state),
                DevoirRAFRA: getDevoirRachatDevoirConseilDemandeTarifInit(state),
            },
        },
        DemandeContrat: {
            DevisHamon: getDevisHamonDemandeContratInit(state) ? '1' : '0',
            DevisHamonAssureurActuel:
                getDevisHamonAssureurActuelNameDemandeContratInit(state) &&
                getDevisHamonAssureurActuelIdDemandeContratInit(state)
                    ? `${getDevisHamonAssureurActuelIdDemandeContratInit(
                          state,
                      )}|${getDevisHamonAssureurActuelNameDemandeContratInit(state)}`
                    : null,
            DevisHamonAssureurActuelName: getDevisHamonAssureurActuelNameDemandeContratInit(state),
            DevisHamonAssureurActuelId: getDevisHamonAssureurActuelIdDemandeContratInit(state),
            DevisHamonContratActuel: getDevisHamonContratActuelDemandeContratInit(state),
            ModePaiementTerme: 'P',
            Signature: true,
            SignatureEmail: getSignatureEmailDemandeContratInit(state) || getEmailSouscripteurTarif(state),
            SignaturePhone: getSignaturePhoneDemandeContratInit(state) || getTelPortableSouscripteurTarif(state),
            NomTitulaire:
                getNomTitulaireDemandeContratInit(state) != 'undefined undefined'
                    ? getNomTitulaireDemandeContratInit(state)
                    : `${getNomPersonnePrincipaleDemandeTarifInit(state)} ${getPrenomPersonnePrincipaleDemandeTarifInit(
                          state,
                      )}`,
            IBAN: getIBANDemandeContratInit(state),
            BIC: getBICDemandeContratInit(state),
            DateHeureEffet: getDevisHamonDemandeContratInit(state) ? getDateHeureEffetDemandeContratInit(state) : moment().add(30, 'minutes').format('DD/MM/YYYY HH:mm'),
            TiersPayeur: !_.isEmpty(getTiersPayeurDemandeContratInit(state))
                ? {
                      Type: getTiersPayeurTypeDemandeContratInit(state) || 'P',
                      LastName: getTiersPayeurLastNameDemandeContratInit(state),
                      BirthName: getTiersPayeurBirthNameDemandeContratInit(state),
                      FirstName: getTiersPayeurFirstNameDemandeContratInit(state),
                      BirthDate: getTiersPayeurBirthDateDemandeContratInit(state),
                      BirthCountry: getTiersPayeurBirthCountryDemandeContratInit(state),
                      BirthCity: getTiersPayeurBirthCityDemandeContratInit(state),
                      Relationship: getTiersPayeurRelationshipDemandeContratInit(state),
                      ThirdPayerReason: getTiersPayeurThirdPayerReasonDemandeContratInit(state),
                  }
                : {},
        },
    };
};
